import React from 'react';
import './FormSection.css';

/**
 * Form section with title and a grid of children.
 */
export default function FormSection({ title, children, className = '' }) {
  return (
    <section className={`form-section ${className}`.trim()}>
      {title && <h2 className="form-section-title">{title}</h2>}
      <div className="form-section-grid">{children}</div>
    </section>
  );
}
